import { useMemo, useState } from 'react';
import dayjs from 'dayjs';
import useApiResult from './useApiResult';
import { getUserAbsences, postUserAbsences } from '../promises/getUserAbsences';

function useUserAbsences() {
  const todaysDate = dayjs().toDate();
  const [triggerCounter, setTriggerCounter] = useState(0);

  const userAbsencesResults = useMemo(
    () => getUserAbsences(todaysDate),
    [triggerCounter]
  );

  const { loading, error, result } = useApiResult(userAbsencesResults);

  function refetch() {
    setTriggerCounter((prev) => prev + 1);
  }

  async function addUserAbsences(daysOfAbsence: number) {
    try {
      await postUserAbsences(todaysDate, daysOfAbsence);
    } catch (e) {
      console.error(e);
    }
  }

  return {
    loading,
    error,
    userAbsences: result,
    addUserAbsences,
    refetch,
  };
}

export default useUserAbsences;
